import { render, staticRenderFns } from "./OurTeam-fr.vue?vue&type=template&id=5cb5d76c&"
import script from "./OurTeam-fr.vue?vue&type=script&lang=js&"
export * from "./OurTeam-fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports